import {Chip} from "@mui/material";
import {Filter} from "@variocube/app-ui";
import React from "react";
import {CreditFilter} from "../../../api";
import {useLocalization} from "../../../i18n";

interface CreditorFilterBarProps {
	value: CreditFilter;
	onChange: (value: CreditFilter) => void;
}

export function CreditorFilterBar({value, onChange}: CreditorFilterBarProps) {
	const {s, t} = useLocalization();

	return (
		<Filter
			labels={s("filter")}
			label={t("filter.title")}
			onClear={() => onChange({})}
			enableSearch
			onSearch={query => onChange({companyName: query})}
			active={[
				value.companyName && (
					<Chip
						label={`${t("common.name")}: ${value.companyName}`}
						onDelete={() => onChange({...value, companyName: ""})}
					/>
				),
			]}
		/>
	);
}
